import { render, staticRenderFns } from "./invPallet.vue?vue&type=template&id=0edf61e6&scoped=true&"
import script from "./invPallet.js?vue&type=script&lang=js&"
export * from "./invPallet.js?vue&type=script&lang=js&"
import style0 from "./invPallet.scss?vue&type=style&index=0&id=0edf61e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf61e6",
  null
  
)

export default component.exports